import { Box } from "@mui/material";
import styled from "styled-components";

export const Content = styled(Box)`
  top: 50%;
  left: 50%;
  right: auto;
  bottom: auto;
  margin-right: -50%;
  transform: translate(-50%, -50%);
  position: absolute;
  background: ${({ theme }) => theme.palette.background.paper};
  border-radius: ${({ theme }) => theme.shape.borderRadius}px;
  align-items: left;
  display: flex;
  flex-direction: column;
  text-align: left;
  padding: 35px 35px 20px 35px;

  @media (min-width: 600px) {
    width: 620px;
  }
`;

export const ActionsContainer = styled.div`
  margin-top: 45px;
  display: flex;
  justify-content: space-between;

  > button:first-child {
    margin-right: 10px;
  }
`;

export const Form = styled.form`
  margin-top: 15px;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
`;

export const RowPermission = styled.div`
  display: grid;
  grid-template-columns: 1fr 2fr;
  flex-direction: row;
  justify-content: space-between;
  gap: 20px;

  div:first-child {
    margin-left: 0px;
  }
`;

export const ContainerButton = styled.div`
  display: flex;
  gap: 10px;
`;

export const Instructions = styled.div`
  display: flex;
  align-items: center;
  margin-top: 8px;
`;
